import { axiosClient } from "../api/axiosClient";

import type {
  FormChatFieldInput,
  FormChatSelectionPayload,
} from "gsintegrations";

export type OnboardingFormChatStep =
  | "personal"
  | "terreiro"
  | "guardian"
  | "password"
  | "financial"
  | "subscription"
  | "address"
  | "documents"
  | "review"
  | "complete";

export interface OnboardingChatFormState {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  birthDate?: string;
  terreiroName?: string;
  religionId?: string;
  foundationDate?: string;
  initiationDate?: string;
  rankId?: string;
  roleId?: string;
  guardianName?: string;
  guardianPhone?: string;
  guardianRelationship?: string;
  password?: string;
  confirmPassword?: string;
  documentType?: string;
  document?: string;
  contact?: string;
  street?: string;
  number?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  hasBankAccount?: boolean;
  bankOptionId?: string;
  agency?: string;
  account?: string;
  pixKeyType?: string;
  pixKey?: string;
  initialBalance?: string;
  monthlyFee?: string;
  dueDay?: string;
  receivingAccount?: string;
  paymentMethod?: string;
}

export interface OnboardingChatSummary {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  birthDate?: string;
  terreiroName?: string;
  religionName?: string;
  guardianName?: string;
  guardianPhone?: string;
  guardianRelationship?: string;
  documentType?: string;
  document?: string;
  street?: string;
  number?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  rankName?: string;
  roleName?: string;
  hasPassword?: boolean;
  bankName?: string;
  monthlyFee?: string;
  dueDay?: string;
  paymentMethod?: string;
}

export interface OnboardingFormChatReferenceData {
  religions?: Array<{ id: string; name: string }>;
  ranks?: Array<{ id: string; name: string }>;
  roles?: Array<{ id: string; name: string }>;
  bankOptions?: string[];
}

export interface OnboardingFormChatMessageRequest {
  sessionId?: string;
  entityType: "terreiro_onboarding" | "medium_onboarding";
  mode: "quick" | "complete";
  isSocialAuth?: boolean;
  message: string;
  action?: "confirm" | "edit_field";
  editField?: string;
  inputMode?: "text" | "voice";
  referenceData?: OnboardingFormChatReferenceData;
  prefilledData?: OnboardingChatFormState;
  selection?: FormChatSelectionPayload;
}

export interface OnboardingFormChatMessageResponse {
  sessionId: string;
  assistantMessage: string;
  currentStep: OnboardingFormChatStep;
  formState: OnboardingChatFormState;
  isComplete: boolean;
  quickReplies?: string[];
  activeField?: string;
  fieldInput?: FormChatFieldInput;
  validationErrors?: Record<string, string>;
  summary?: OnboardingChatSummary;
}

export const onboardingFormChatRepository = {
  async sendMessage(
    payload: OnboardingFormChatMessageRequest,
  ): Promise<OnboardingFormChatMessageResponse> {
    const response = await axiosClient.post(
      "/onboarding-form-chat/message",
      payload,
    );
    return response.data as OnboardingFormChatMessageResponse;
  },
};
